import { useEffect, useState } from "react";
import { columns, faqs, siteNav } from "@/mocks/editorial";

export default function Footer() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <>
      <footer className="bg-paper-200 py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-ember-600 text-paper-50">
                  <i className="ri-quill-pen-fill text-lg" />
                </span>
                <span className="font-display text-xl font-black text-ink-900">大瓜观察局</span>
              </div>
              <p className="mt-4 max-w-xs text-sm leading-relaxed text-ink-600">
                专注综艺内幕与争议议题的中文媒体观察站，以行业常识与传播学视角拆解台本、剪辑与舆论现象。
              </p>
            </div>

            <div>
              <h4 className="mb-4 font-display text-sm font-bold tracking-wide text-ink-900">栏目导航</h4>
              <ul className="flex flex-col gap-2.5 text-sm text-ink-600">
                {siteNav.map((n) => (
                  <li key={n.id}>
                    <button onClick={() => go(n.id)} className="cursor-pointer transition hover:text-ember-700">
                      {n.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="mb-4 font-display text-sm font-bold tracking-wide text-ink-900">议题分类</h4>
              <ul className="flex flex-col gap-2.5 text-sm text-ink-600">
                {columns.map((c) => (
                  <li key={c.id}>
                    <button onClick={() => go("deep")} className="cursor-pointer transition hover:text-ember-700">
                      {c.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="mb-4 font-display text-sm font-bold tracking-wide text-ink-900">联系编辑部</h4>
              <ul className="flex flex-col gap-3 text-sm text-ink-600">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-ember-600" />
                  <span>contact@dagua.example</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-ember-600" />
                  <span>每周一、三、五更新</span>
                </li>
              </ul>
              <button
                onClick={() => go("feedback")}
                className="mt-5 cursor-pointer whitespace-nowrap rounded-full bg-ink-900 px-5 py-2.5 text-sm text-paper-50 transition hover:bg-ember-700"
              >
                线索投稿
              </button>
            </div>
          </div>

          <div className="mt-10 border-t border-paper-300 pt-6">
            <p className="text-xs leading-relaxed text-ink-500">
              免责声明：本站内容均为行业现象观察与媒体分析，基于公开信息与传播学常识撰写，不对现实具体人物发布未经证实的信息或人格贬损内容。读者请理性看待网络流传的片段化信息。
            </p>
            <div className="mt-4 flex flex-col gap-2 text-xs text-ink-500 sm:flex-row sm:items-center sm:justify-between">
              <p>© 2026 大瓜观察局 · 仅供演示的内容观察站</p>
              <p className="flex items-center gap-4">
                <a href="#about" className="transition hover:text-ember-700">编辑部</a>
                <a href="#faq" className="transition hover:text-ember-700">用户问答</a>
                <a href="#feedback" className="transition hover:text-ember-700">联系方式</a>
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* 回到顶部 */}
      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="回到顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-ink-900 text-paper-50 shadow-soft transition hover:bg-ember-700"
        >
          <i className="ri-arrow-up-line" />
        </button>
      )}
    </>
  );
}

export function StructuredData() {
  const json = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        name: "大瓜观察局",
        description:
          "专注综艺内幕、台本工业、剪辑叙事与选手导师争议观察的媒体站。",
        url: "https://gdcxjg.cn/",
      },
      {
        "@type": "WebSite",
        name: "大瓜观察局",
        url: "https://gdcxjg.cn/",
      },
      {
        "@type": "CollectionPage",
        name: "大瓜观察局 · 综艺内幕追踪",
        description:
          "深挖综艺剧本造假、剪辑黑幕、选手争议与导师风波，以行业视角拆解镜头之外的真实运作。",
        url: "https://gdcxjg.cn/",
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }} />;
}